import { render, staticRenderFns } from "./FormPurchases.vue?vue&type=template&id=06a6f9e0&scoped=true"
import script from "./FormPurchases.vue?vue&type=script&lang=js"
export * from "./FormPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a6f9e0",
  null
  
)

export default component.exports